module.exports = __webpack_public_path__ + "static/media/Beartic_gaussian2.1f53ea83.png";